import { Injectable } from '@angular/core';
import { AppService } from '../../../../../core/service/Base.Service';
import { DataTransferObject } from '../../../../../core/entities/DataTransferObject';

@Injectable()
export class SMStudentinfoService extends AppService<any> {

    constructor() {
        super('Studentinfo');

    }

    async getStudent(entityid: any) {
        const result = await this.get('Student', entityid);
        return result;
    }

    async getStatusWiseStudent(entityid: any, lovstatusid) {
        const result = await this.get('StatusWiseStudent', [entityid, lovstatusid]);
        return result;
    }

    async getStatusWiseStudentAcademicYear(entityid: any, lovstatusid, acdyearid) {
        const result = await this.get('StatusWiseStudent', [entityid, lovstatusid,acdyearid]);
        return result;
    }




    async getStudentList(feeforid: any, applyonid) {
        const result = await this.get('StudentList', [feeforid, applyonid]);
        return result;
    }

    async getStatusWiseStudentList(feeforid: any, applyonid, lovstatusid) {
        const result = await this.get('StatusWiseStudentList', [feeforid, applyonid, lovstatusid]);
        return result;
    }


    async getstudentList(entityid: number, driverid: number, routeid: number, guardianid: number, regno: string, name: string, genderid: number, religionid: number, shiftid: number, courseid: number) {

        const result = await this.get('StudentList', [entityid, driverid, routeid, guardianid, regno, name, genderid, religionid, shiftid, courseid]);
        return result;
    }

    async getRoutesStudents(routeid) {
        return await this.get('RoutesStudents', [routeid])

    }

    async getGuardianStudent(guardianid) {
        return await this.get('GuardianStudent', [guardianid])

    }

    async getStatusWiseRoutesStudents(routeid, lovstatusid) {
        return await this.get('StatusWiseRoutesStudents', [routeid, lovstatusid]);
    }
    async getEntityStudent(entityid) {
        const result = await this.get('Student', entityid);
        return result;
    }

    async geStudentList(studentid) {
        const result = await this.get('StudentList', studentid);
        return result;
    }

    async getStatusWiseStudentsList(studentid, lovstatusid) {
        const result = await this.get('StatusWiseStudentList', [studentid, lovstatusid]);
        return result;
    }

    async getCourseStudents(courseid, sectionid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('CourseStudents', [entityid, courseid, sectionid]);
        return result;
    }

    async getStatusWiseCourseStudents(courseid, sectionid, lovstatusid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('StatusWiseCourseStudents', [entityid, courseid, sectionid, lovstatusid]);
        return result;
    }

    async GetStudentGuardian(guardianid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('GuardianStudent', [entityid, guardianid]);
        return result;
    }

    async GetStatusWiseStudentGuardian(guardianid, lovstatusid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('StatusWiseGuardianStudent', [entityid, guardianid, lovstatusid]);
        return result;
    }

    async getStudentByFilter(clientid, entityid, studentno, dateofbirth, curcourseid, cursectionid, genderid, firstname, fathername) {

        let refclientid = (clientid == undefined || clientid == 0 || clientid == "") ? this.localStorage.get("clientid") : clientid;
        let refentityid = (entityid == undefined || entityid == 0 || entityid == "") ? this.localStorage.get("selectedEntity") : entityid;
        let refstudentno = (studentno == "" || studentno == undefined) ? 'null' : studentno;
        let refdateofbirth = (dateofbirth == "" || dateofbirth == undefined) ? 'null' : dateofbirth;
        let refcurcourseid = (curcourseid == undefined || curcourseid == 0 || curcourseid == "") ? 'null' : curcourseid;
        let refcursectionid = (cursectionid == undefined || cursectionid == 0 || cursectionid == "") ? 'null' : cursectionid;
        let refgenderid = (genderid == undefined || genderid == 0 || genderid == "") ? 'null' : genderid;
        let reffirstname = (firstname == undefined || firstname == 0 || firstname == "") ? 'null' : firstname;
        let reffathername = (fathername == undefined || fathername == 0 || fathername == "") ? 'null' : fathername;


        const result = await this.get('StudentByFilter', [refclientid, refentityid, refstudentno, refdateofbirth, refcurcourseid, refcursectionid, refgenderid, reffirstname, reffathername]);

        return result;
    }



    async getStudentCourseSection(entityid, acdyearid, courseid, sectionid, fromdate, tilldate) {

        let refcourseid = (courseid == undefined || courseid == 0 || courseid == "") ? 'null' : courseid;
        let refsectionid = (sectionid == undefined || sectionid == 0 || sectionid == "") ? 'null' : sectionid;
        let reffromdate = (fromdate == "" || fromdate == undefined) ? 'null' : fromdate;
        let reftilldate = (tilldate == "" || tilldate == undefined) ? 'null' : tilldate;
        const result = await this.get('StudentCourseSection', [entityid, acdyearid, refcourseid, refsectionid, reffromdate, reftilldate]);
        return result;
    }

    async getStudentInformation(clientid, entityid, lovstatusid) {

        let reflovstatusid = (lovstatusid == undefined || lovstatusid == 0 || lovstatusid == "") ? 'null' : lovstatusid;
        const result = await this.get('StatusWiseStudentInformation', [clientid, entityid, reflovstatusid]);
        return result;
    }

    async getStudentListRollNo(entityid, courseid, sectionid) {

        const result = await this.get('StudentList', [entityid, courseid, sectionid]);
        return result;
    }

    async getStatusWiseStudentListRollNo(entityid, courseid, sectionid, lovstatusid) {

        const result = await this.get('StatusWiseStudentList', [entityid, courseid, sectionid, lovstatusid]);
        return result;
    }
    async getStatusWiseStudentInformation(clientid, entityid, lovstatusid) {

        const result = await this.get('StatusWiseStudentInformation', [clientid, entityid, lovstatusid]);
        return result;
    }

    async GetStudentCourseSectionSubject(entityid, acdyearid, courseid, sectionid, subjectid, fromdate, tilldate) {

        let refcourseid = (courseid == undefined || courseid == 0 || courseid == "") ? 'null' : courseid;
        let refsectionid = (sectionid == undefined || sectionid == 0 || sectionid == "") ? 'null' : sectionid;
        let refsubjectid = (subjectid == undefined || subjectid == 0 || subjectid == "") ? 'null' : subjectid;
        let reffromdate = (fromdate == "" || fromdate == undefined) ? 'null' : fromdate;
        let reftilldate = (tilldate == "" || tilldate == undefined) ? 'null' : tilldate;
        const result = await this.get('StudentCourseSectionSubject', [entityid, acdyearid, refcourseid, refsectionid, refsubjectid, reffromdate, reftilldate]);
        return result;
    }

    async GetCourseSectionStudents(entityid, assignmentid, totalmarks, courseid, sectionid) {
        entityid = Number(this.localStorage.get('selectedEntity'));
        const result = await this.get('CourseSectionStudents', [entityid, assignmentid, totalmarks, courseid, sectionid]);
        return result;
    }

    async getStudentSiblings(studentid, cnic, fathermobile) {
     let CNIC = cnic.trim();
        if (CNIC.length < 10) {
            const result = await this.get('StudentSiblings', [studentid, 'null', fathermobile]);
            return result;
        }
        else {
            const result = await this.get('StudentSiblings', [studentid, cnic, fathermobile]);
            return result;
        }

    }


    async getFiltersStudents(entityid, studentno, dateofbirth, curcourseid, cursectionid, genderid, firstname, fathername, fathercnic) {

        let refentityid = (entityid == undefined || entityid == 0 || entityid == "") ? this.localStorage.get("selectedEntity") : entityid;
        let refstudentno = (studentno == "" || studentno == undefined) ? 'null' : studentno;
        let refdateofbirth = (dateofbirth == "" || dateofbirth == undefined) ? 'null' : dateofbirth;
        let refcurcourseid = (curcourseid == undefined || curcourseid == 0 || curcourseid == "") ? 'null' : curcourseid;
        let refcursectionid = (cursectionid == undefined || cursectionid == 0 || cursectionid == "") ? 'null' : cursectionid;
        let refgenderid = (genderid == undefined || genderid == 0 || genderid == "") ? 'null' : genderid;
        let reffirstname = (firstname == undefined || firstname == 0 || firstname == "") ? 'null' : firstname;
        let reffathername = (fathername == undefined || fathername == 0 || fathername == "") ? 'null' : fathername;
        let reffathercnic = (fathercnic == undefined || fathercnic == 0 || fathercnic == "") ? 'null' : fathercnic;


        const result = await this.get('FiltersStudents', [refentityid, refstudentno, refdateofbirth, refcurcourseid, refcursectionid, refgenderid, reffirstname, reffathername, reffathercnic]);

        return result;
    }

    async getFiltersStudentsV2(entityid, studentno, dateofbirth, curcourseid, cursectionid, genderid, firstname, fathername, fathercnic,grno) {

        let refentityid = (entityid == undefined || entityid == 0 || entityid == "") ? this.localStorage.get("selectedEntity") : entityid;
        let refstudentno = (studentno == "" || studentno == undefined) ? 'null' : studentno;
        let refdateofbirth = (dateofbirth == "" || dateofbirth == undefined) ? 'null' : dateofbirth;
        let refcurcourseid = (curcourseid == undefined || curcourseid == 0 || curcourseid == "") ? 'null' : curcourseid;
        let refcursectionid = (cursectionid == undefined || cursectionid == 0 || cursectionid == "") ? 'null' : cursectionid;
        let refgenderid = (genderid == undefined || genderid == 0 || genderid == "") ? 'null' : genderid;
        let reffirstname = (firstname == undefined || firstname == 0 || firstname == "") ? 'null' : firstname;
        let reffathername = (fathername == undefined || fathername == 0 || fathername == "") ? 'null' : fathername;
        let reffathercnic = (fathercnic == undefined || fathercnic == 0 || fathercnic == "") ? 'null' : fathercnic;
        let Grno = (grno == undefined || grno == 0 || grno == "") ? 'null' : grno;



        const result = await this.get('FiltersStudents', [refentityid, refstudentno, refdateofbirth, refcurcourseid, refcursectionid, refgenderid, reffirstname, reffathername, reffathercnic,Grno]);

        return result;
    }

    async getstudentbirthdays() {
        let entityid = Number(this.localStorage.get('selectedEntity'));
        const result = await this.get('StudentBirthdays', [entityid]);
        return result;
    }

    async getCNICagainstFatherdata(cnic) {
        const result = await this.get('CNICagainstFatherdata', [cnic]);
        return result;
    }

    async getCNICagainstMotherdata(cnic) {
        const result = await this.get('CNICagainstMotherdata', [cnic]);
        return result;
    }
    async getStudentsWithMarks(courseid, sectionid, examid, subjectid) {

        let entityid = Number(this.localStorage.get('selectedEntity'));
        const result = await this.get('StudentsWithMarks', [entityid, courseid, sectionid, examid, subjectid]);
        return result;
    }

    async GetCourseAgainstStudents(courseid, sectionid, subjectid, lovstatusid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('CourseAgainstStudents', [entityid, courseid, sectionid, subjectid, lovstatusid]);
        return result;
    }

    async GetPromoteStudent(acdyearid, courseid, sectionid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('PromoteStudent', [entityid, acdyearid, courseid, sectionid]);
        return result;
    }


    async getStudentNotifySMSorApp(entityid: any) {
        const result = await this.get('StudentNotifySMSorApp', [entityid]);
        return result;
    }
    async getguardianagaintsstud(Id) {
        const result = await this.get('StudentDetail', [Id, 'null']);
        return result;
    }

    ChildList = [];
    async getChildList(Id) {
        const result = await this.getguardianagaintsstud(Id);
        if (result && result.IsSuccess) {
            this.ChildList = result.Data;
        }
    }



    async getguesttypestudent(clientid, entityid) {

        const result = await this.get('StatusWiseStudentInformation', [clientid, entityid, 357]);
        return result;
    }

    async deletechild(stdid, gurid) {
        const result = await this.get('GuardianStudentDelete', [stdid, gurid]);
        return result;
    }

    async getStudentEntity(entityid) {
        const result = await this.get('Students', entityid);
        return result;
    }
	async bulkstudetnsaving(Data){
        const _data = <DataTransferObject<any>>{
            Data: Data,
        };
        
        const result = await this.post('Bulkstudentsaving',_data);
        return result;
    }

    async getCourseAgainstStudent(entityid,teacherid)
    {
        const result = await this.get('CourseAgainstStudent', [entityid,teacherid]);
        return result;
    }

     async GetPromoteStudentdata(acdyearid) {
        let entityid = this.localStorage.get('selectedEntity');
        const result = await this.get('PromoteStudent', [entityid, acdyearid]);
        return result;
    }

    async getStudentGuardianWise(entityid, guardianid, guardiancpr){

         const getentityid = this.localStorage.get("selectedEntity");  
         const result = await this.get('GuardianStudent', [entityid , guardianid , guardiancpr]);
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/shell/forms/school-management/transaction/studentprofile/studentprofile.service.ts